module.exports = __webpack_public_path__ + "static/media/PaymentOptionsScreen.0c4cd269.png";